import { terminologyConfig } from '../terminology/store';
// config/ResellerConfig.js

const ResellerConfig = terminologyConfig({

  // ── Reseller entity labels 
  reseller: {
    label:  'Reseller',
    emptyMessage: 'No customers found.',
  },

  // ── Client (core) entity labels ────────────
  clients: {
    label:        'Investor',
    plural:       'Investors',
    emptyMessage: 'No investors found.',
  },

  // ── Enterprise Client entity labels ────────
  enterpriseClient: {
    label:        'Mutual Client',
    plural:       'Mutual Clients',
    emptyMessage: 'No mutual clients found.',
  },

  // ── Reports config ────────
  reports: {
    label: 'Reports',
    icon:  'file-earmark-fill',
    items: {
      user:       'User Report',
      commission: 'Commission Report',
      usage:      'Usage Report',
    },
  },

  nav: {
    clients: {
      label: 'Investors',   // tab button text
      icon:  'people-fill',
    },
    enterpriseClients: {
      label: 'Mutual Clients',
      icon:  'building-fill',
    },
    reports: {
      label: 'Reports',
      icon:  'file-earmark-fill',
    },
    account: {
      label: 'My Account',
      icon:  'person-lines-fill',
    },
  },

  // ── Page / breadcrumb titles ──
  pageTitles: {
    clientList:       'Investor Management',
    addClient:        'Add New Investor',
    editClient:       'Edit Investor',
    enterpriseList:   'Mutual Client Management',
    addEnterprise:    'Add New Mutual Client',
    editEnterprise:   'Edit Mutual Client',
    reports:          'Reports',
    account:          'My Account',
  },

  // ── Confirmation / modal text ─
  modal: {
    confirmActivate:   (label) => `Are you sure you want to activate this ${label.toLowerCase()}?`,
    confirmDeactivate: (label) => `Are you sure you want to deactivate this ${label.toLowerCase()}?`,
    confirmDelete:     (label) => `Are you sure you want to delete this ${label.toLowerCase()}?`,
  },
}, {
  "reseller.label": [
    "reseller",
    "singular",
    "{name}"
  ],
  "reseller.singular": [
    "reseller",
    "singular",
    "{name}"
  ],
  "reseller.plural": [
    "reseller",
    "plural",
    "{name}"
  ],
  "reseller.pluralLabel": [
    "reseller",
    "plural",
    "{name}"
  ],
  "reseller.pageHeading": [
    "reseller",
    "plural",
    "{name}"
  ],
  "reseller.managementLabel": [
    "reseller",
    "singular",
    "{name} Management"
  ],
  "reseller.emptyMessage": [
    "reseller",
    "plural",
    "No {name} found."
  ],
  "clients.label": [
    "client",
    "singular",
    "{name}"
  ],
  "clients.singular": [
    "client",
    "singular",
    "{name}"
  ],
  "clients.plural": [
    "client",
    "plural",
    "{name}"
  ],
  "clients.pluralLabel": [
    "client",
    "plural",
    "{name}"
  ],
  "clients.pageHeading": [
    "client",
    "plural",
    "{name}"
  ],
  "clients.managementLabel": [
    "client",
    "singular",
    "{name} Management"
  ],
  "clients.emptyMessage": [
    "client",
    "plural",
    "No {name} found."
  ],
  "nav.clients.label": [
    "client",
    "plural",
    "{name}"
  ],
  "pageTitles.clientList": [
    "client",
    "singular",
    "{name} Management"
  ],
  "pageTitles.addClient": [
    "client",
    "singular",
    "Add New {name}"
  ],
  "pageTitles.editClient": [
    "client",
    "singular",
    "Edit {name}"
  ]
});

export default ResellerConfig;